<template>
  <div class="pt-4">
    <div class="mb-4">
      CLUSTERS
    </div>
    <div class="row m-0">
      <div
        v-for="(result, index) in data"
        :key="index"
        class="col-12 col-sm-6 col-md-4 m-0 p-1"
      >
        <Square
          class="deepify-light-bg"
          :class="getSquareClass(index, data.length)"
          @click.native="isResearchNameModalVisible = true"
        >
          <div class="d-flex flex-column justify-content-between h-100">
            <div class="mb-1 px-3 pt-3">
              <div
                class="w-100 mb-2"
                style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; "
              >
                <span class="text-uppercase">{{ result.name }}</span>
                <span class="reach-title deepify-gray-text d-block py-1">
                  <i>Reach: {{ result.size }}</i>
                </span>
              </div>
            </div>
            <div class="px-3">
              <OceanAgeChart
                :data="Object.keys(result.cluster.facebookAgeStatistics).map(
                  k=> result.cluster.facebookAgeStatistics[k])"
              />
            </div>
            <div class="px-3">
              <OceanScoreChart
                class="ocean-score mx-auto mb-2"
                :data="result.cluster.oceanScores"
              />
            </div>
            <div
              class="cluster-indexes w-100 px-3 p-2"
            >
              <small
                v-for="i in 3"

                :key="i"
                class="cluster-index d-block"
              >
                <i>
                  {{ i }}-
                  {{ result.data[i-1].name }} [{{ result.data[i-1].type }}]:
                  {{ result.data[i-1].value.toFixed(2) }}
                </i>
              </small>
            </div>
          </div>
        </Square>
      </div>
    </div>
  </div>
</template>
<script>
import Square from '@/components/core/Square.vue';

import OceanAgeChart from '@/components/OceanAgeChart.vue';
import OceanScoreChart from '@/components/OceanScoreChart.vue';

export default {
  components: {
    Square,
    OceanAgeChart,
    OceanScoreChart,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getSquareClass(index, length) {
      if (index < 3) return 'rounded-bottom-2';
      if (length > 5 && index < length - (length % 3 > 0 ? length % 3 : 3)) return 'rounded-2';
      return 'rounded-top-2';
    },
  },
};
</script>
<style scoped>
  .cluster {
    background: #f4f4f4;
  }

  .ocean-score {
    width: 40%;
  }

  .reach-title {
    font-size: 11px;
  }

  .cluster-indexes {
    bottom: 0;
    border-top: 2px white solid;
  }

  .cluster-index {
    font-size: 8px;
  }
</style>
